import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { useEffect, useState } from "react";
export const AnimatedTelesales = t0 => {
  const $ = _c(7);
  const {
    onClick
  } = t0;
  const [animationState, setAnimationState] = useState("icon");
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const timer1 = setTimeout(() => {
        setAnimationState("text");
      }, 2000);
      const timer2 = setTimeout(() => {
        setAnimationState("icon");
      }, 6000);
      return () => {
        clearTimeout(timer1);
        clearTimeout(timer2);
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <MaterialIcon className="absolute right-3 top-2 text-2xl" name="phone_enabled" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = animationState === "text" ? "\u0631\u0632\u0631\u0648 \u062A\u0644\u0641\u0646\u06CC" : undefined;
  const t5 = `shadow-4 !fixed bottom-[80px] left-0 z-[12] flex items-center justify-center gap-3 rounded-full !rounded-l-none bg-white px-4 py-2 transition-all duration-1000 ease-in-out ${animationState === "text" ? "w-[150px] translate-y-0 opacity-100" : "w-[50px] translate-y-0 opacity-100"}`;
  let t6;
  if ($[3] !== onClick || $[4] !== t4 || $[5] !== t5) {
    t6 = <Button StartIcon={t3} children={t4} className={t5} color="secondary" onClick={onClick} size="large" variant="round" />;
    $[3] = onClick;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};